var classes = {"root":"q--tc","currentNumber":"jVnGr","totalNumber":"CKB1C"};

export { classes as default };
